var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0357 9.82415C15.0357 12.2934 13.034 14.2951 10.5647 14.2951C8.09548 14.2951 6.09375 12.2934 6.09375 9.82415C6.09375 7.35488 8.09548 5.35315 10.5647 5.35315C13.034 5.35315 15.0357 7.35488 15.0357 9.82415Z",
    fill: "#0F3C56",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5651 18.9791C15.6212 18.9791 19.72 14.8804 19.72 9.82424C19.72 4.76813 15.6212 0.66934 10.5651 0.66934C5.50897 0.66934 1.41018 4.76813 1.41018 9.82424C1.41018 14.8804 5.50897 18.9791 10.5651 18.9791ZM10.5651 19.4049C15.8564 19.4049 20.1458 15.1155 20.1458 9.82424C20.1458 4.53296 15.8564 0.24353 10.5651 0.24353C5.2738 0.24353 0.984375 4.53296 0.984375 9.82424C0.984375 15.1155 5.2738 19.4049 10.5651 19.4049Z",
    fill: "#0F3D57",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCircle);
export default __webpack_public_path__ + "static/media/Card-circle.a79f4e579e3d8f327093d5ce13cb8079.svg";
export { ForwardRef as ReactComponent };